export default "__VITE_ASSET__COOBdV0___"